import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import "./styles/Terms.css";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-page">

      <div className="terms-container">

        <button
          className="page-back-btn"
          onClick={() => navigate("/")}
        >
          ← Back to Home
        </button>

        <div className="terms-header">
          <span>LEGAL AGREEMENT</span>

          <h1>Terms & Conditions</h1>

          <p>
            These Terms and Conditions govern the use of Genesis HRMS and
            related services provided by Genesis Tech Engineers Pvt. Ltd.
            By accessing or using the platform, you agree to comply with
            these terms.
          </p>
        </div>

        <div className="terms-content">

          <div className="terms-section">
            <h2>Acceptance of Terms</h2>

            <p>
              By accessing, registering for, purchasing, or using Genesis
              HRMS, you acknowledge that you have read, understood, and
              agreed to be bound by these Terms and Conditions.
            </p>
          </div>

          <div className="terms-section">
            <h2>Use of Services</h2>

            <p>
              Genesis HRMS may only be used for lawful business purposes.
              Customers are responsible for maintaining the confidentiality
              of login credentials and ensuring authorized use of the
              platform within their organization.
            </p>
          </div>

          <div className="terms-section">
            <h2>Subscription & Licensing</h2>

            <p>
              Access to Genesis HRMS is provided through subscription-based
              licensing. Features, user limits, and service availability
              depend on the selected subscription plan purchased by the
              customer.
            </p>
          </div>

          <div className="terms-section">
            <h2>Payment Terms</h2>

            <p>
              All subscription fees are payable in advance based on the
              selected plan duration and employee count. Prices displayed
              on the platform are exclusive of applicable taxes unless
              otherwise specified.
            </p>

            <p>
              Payments are processed securely through authorized payment
              gateways. Customers are responsible for providing accurate
              billing and payment information.
            </p>

            <ul>
              <li>Subscription fees are non-refundable once activated.</li>
              <li>Applicable GST and taxes will be charged separately.</li>
              <li>Failure to complete payment may result in suspension of services.</li>
              <li>Renewal pricing may be subject to future revisions.</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>Customer Responsibilities</h2>

            <p>
              Customers are responsible for ensuring that all information
              uploaded into the system is accurate, lawful, and properly
              authorized. Customers remain the owners of their data.
            </p>
          </div>

          <div className="terms-section">
            <h2>Intellectual Property Rights</h2>

            <p>
              Genesis HRMS, its software, source code, trademarks,
              branding, designs, documentation, and related intellectual
              property remain the exclusive property of Genesis Tech
              Engineers Pvt. Ltd.
            </p>
          </div>

          <div className="terms-section">
            <h2>Service Availability</h2>

            <p>
              While we strive to maintain uninterrupted service, Genesis
              Tech Engineers does not guarantee continuous availability.
              Scheduled maintenance, upgrades, or unforeseen technical
              issues may temporarily affect access.
            </p>
          </div>

          <div className="terms-section">
            <h2>Limitation of Liability</h2>

            <p>
              Genesis Tech Engineers shall not be liable for any indirect,
              incidental, special, or consequential damages arising from
              the use or inability to use the platform, including data
              loss, business interruption, or loss of profits.
            </p>
          </div>

          <div className="terms-section">
            <h2>Termination</h2>

            <p>
              We reserve the right to suspend or terminate access to the
              platform if these terms are violated, payment obligations are
              not met, or unauthorized activities are detected.
            </p>
          </div>

          <div className="terms-section">
            <h2>Modifications to Terms</h2>

            <p>
              Genesis Tech Engineers reserves the right to update or modify
              these Terms and Conditions at any time. Continued use of the
              platform after such changes constitutes acceptance of the
              revised terms.
            </p>
          </div>

          <div className="terms-section">
            <h2>Contact Information</h2>

            <p>
              For questions regarding these Terms and Conditions, please
              contact:
            </p>

            <p>
              <strong>Genesis Tech Engineers Pvt. Ltd.</strong><br />
              Email: contact@genesistech.co.in<br />
              Phone: +91 7841063605
            </p>
          </div>

        </div>

      </div>

      <Footer />

    </div>
  );
};

export default Terms;